import React, { Component } from "react";
import { connect } from "react-redux";
import { setAssetView } from "../../../actions/ui/passport";
import { getBalancesDispatch } from "../../../actions/passport/get";
import Modal from "../../helper/modal";
import ShowWallet from "../../helper/showWallet";
import { withRouter } from "react-router-dom";
import Dropzone from "react-dropzone";
import { shortenHash} from "../../../config";
import {assets} from '../../../config';

import {
  setBTCWallet,
  setETHWallet,
  setNEOWallet,
  setWAVWallet,
  setLSKWallet,
  setDAIWallet,
  setUSDTWallet,
  setNRGWallet,
  setLEMBWallet,
  setEMBWallet,
  getBTCAddress,
  getETHAddress,
  getNEOAddress,
  getWAVAddress,
  getLSKAddress,
  getDAIAddress,
  getUSDTAddress,
  getEMBAddress,
  getNRGAddress,
  getLEMBAddress,
  removeAsset,
  removeWallet,
} from "../../../actions/passport/set";

import {
  getNEOTransfers,
  getBTCTransfers,
  getETHTransfers,
  getLSKTransfers,
  getWAVTransfers,
  getNRGTransfers,
  getEMBTransfers,
  getDAITransfers,
  getUSDTTransfers,
} from "../../../actions/transfers/get";

import {
  genNEOWallet,
  genBTCWallet,
  genETHWallet,
  genLSKWallet,
  genWAVWallet,
  genDAIWallet,
  genUSDTWallet,
  genNRGWallet,
  genEMBWallet,
  genLEMBWallet,
} from "../../../actions/passport/generate";

import M from "materialize-css/dist/js/materialize.min.js";
import $ from "jquery";
import Circle from "../../helper/circle.jsx";
import {colors} from '../../../config'
import ReactTooltip from 'react-tooltip'
import {Decimal} from 'decimal.js';
var FileSaver = require("file-saver");
let currencies = {
  btc: "Private Key",
  eth: "Private Key",
  dai: "Private Key",
  usdt: "Private Key",
  neo: "Private Key",
  wav: "Seed",
  nrg: "Private Key",
  "l-emb": "Private Key",
  emb: "Private Key",
  lsk: "Passphrase",
};

class Import extends Component {
  constructor() {
    super();
    this.state = {
      title:'nrg',
      name: "BTC",
      wallet: { address: "", type: "", privateKey: "" },
    };
  }
  openModal() {
    setTimeout(() => {
      var instance = M.Modal.getInstance(document.querySelectorAll(`#modalAddress`)[0]);
      instance.open();
      setTimeout(() => {
        if ($(`#wallet${this.props.div}`))
          $(`#wallet${this.props.div}`).focus();
      }, 100);
    }, 200);
  }
  openWallet() {
    let _this = this;
    setTimeout(() => {
      this.props[`gen${this.state.title.replace("-", "").toUpperCase()}Wallet`](
        (wallet) => {
          _this.setState({ wallet });
          var instance = M.Modal.getInstance(
            document.querySelectorAll(`#modalCreate`)[0]
          );
          instance.open();
          setTimeout(() => {
            if ($("#passwordWallet")) $("#passwordWallet").focus();
          }, 100);
        }
      );
    }, 200);
  }
  onSubmit(event) {
    event.preventDefault();
    this.submitOperation();
  }
  submitOperation() {
    let pass = $(`#passAddress`).val();
    if (pass === "") {
      M.toast({ html: "Password must be set", classes: "red" });
      return;
    }

    let walletKey = $(`#walletAddress`).val().trim();
    this.setWallet(walletKey, this.state.address, pass);
  }
  setWallet(privateKey, address, password) {
    this.props[`set${this.state.title.replace("-", "").toUpperCase()}Wallet`](
      privateKey,
      password,
      (err) => {
        if (err) {
          console.log(err)
          M.toast({
            html: `Wallet could not be imported`,
            classes: "red",
            displayLength: 3000,
          });
        } else {
          this.setState({ address: null });
          var instance = M.Modal.getInstance(
            document.querySelectorAll(`#modalAddress`)[0]
          );
          if (instance) instance.close();
          setTimeout(() => {
            this.props.getBalancesDispatch(true);
            this.props[
              `get${this.state.title.replace("-", "").toUpperCase()}Transfers`
            ](() => {});
          }, 100);
          setTimeout(() => {
            this.props.setAssetView(this.state.title, address);
          }, 200);
        }
      }
    );
  }
  toggle() {
    this.setState({ show: !this.state.show });
  }
  renderCard(type,{address, privateKey }) {
    return (
      <div className="col" style={{ textAlign: "left", width: "100%",padding:'10px 10px' }}>
        <div style={{ textAlign: "left" }}>
          <p style={{ color: "grey" }}>Address:</p>
          <p style={{ color: "black", marginBottom:'15px',wordBreak:'break-word' }}>{address}</p>
          <i
            className="material-icons"
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "grey",
              fontSize: "20px"
            }}
            onClick={this.toggle.bind(this)}
          >
            remove_red_eye
          </i>
          <p style={{ color: "grey", float: "left" }}>
            {type.toUpperCase() !=="LSK" && type.toUpperCase() !=="WAV"
              ? "Private Key"
              : "Mnemonic Phrase"}
            :
          </p>
          <p style={{ color: "black",wordBreak:'break-word',height:'50px' }}>
            {this.state.show ? privateKey : "*******************"}
          </p>
        </div>
      </div>
    );
  }
  renderWallet() {
    let component = (
      <div className='row mbd' >
        <div className='col s12' style={{marginBottom:'10px',marginTop:'10px'}}>
          {assets.map((a,index)=>(
            <>{this.renderImage(a)}</>
          ))}
        </div>
        {this.renderCard(this.state.title,this.state.wallet)}
      </div>
    );
    return (
      <Modal
        noClose={true}
        title={`Create ${this.state.title.toUpperCase().replace('NRG','OVERLINE')} Address`}
        style={{ maxWidth: "500px" }}
        decryption={true}
        passwordId={`passwordWallet`}
        id={`modalCreate`}
        classes="modal modalOrders black-text"
        component={component}
        buttonText={"Download and Save*"}
        note={
          "*Save this wallet in a safe and secure manner"
        }
        buttonAction={this.saveWallet.bind(this)}
      />
    );
  }
  saveWallet(event) {
    if (event && event.preventDefault) event.preventDefault();
    let pass = $("#passwordWallet").val();
    if (pass === "") {
      M.toast({ html: "Password must be set", classes: "red" });
      return;
    }
    var blob = new Blob([JSON.stringify(this.state.wallet)], {
      type: "text/javascript;charset=utf-8",
    });
    FileSaver.saveAs(blob, this.state.wallet.type.replace('NRG','OL') + ".json");
    this.setWallet(
      this.state.wallet.privateKey,
      this.state.wallet.address,
      pass
    );

    var instance = M.Modal.getInstance(
      document.querySelectorAll(`#modalCreate`)[0]
    );
    if (instance) instance.close();
  }
  onChangePriv() {
    let walletKey = $(`#walletAddress`).val().trim();
    let address = this.props[
      `get${this.state.title.replace("-", "").toUpperCase()}Address`
    ](walletKey);
    this.setState({ address });
  }
  onDrop(files) {
    var reader = new FileReader();
    let _this = this;

    // Closure to capture the file information.
    reader.onload = (function(theFile) {
      return function(e) {
        try {
          let json = JSON.parse(e.target.result);
          if (json && (json.eth || json.ethWallet) && ['emb','nrg','l-emb'].includes(_this.state.title)) {
            let walletKey = json.eth ? json.eth.privateKey : json.ethWallet.privateKey;
            let address = _this.props[`get${_this.state.title.replace("-", "").toUpperCase()}Address`](walletKey);
            $(`#walletAddress`)[0].value = walletKey;
            _this.setState({ address });
          }
          else if(json.privateKey){
            let walletKey = json.privateKey
            let address = _this.props[`get${_this.state.title.replace("-", "").toUpperCase()}Address`](walletKey);
            $(`#walletAddress`)[0].value = walletKey;

            _this.setState({ address });
          }
          else {
            M.toast({
              html: "Incorrect Wallet Format",
              classes: "red"
            });
          }
        } catch (ex) {
          M.toast({
            html: "Incorrect Wallet Format",
            classes: "red"
          });
        }
      };
    })(files[0]);
    reader.readAsText(files[0]);
  }
  renderModal() {
    let component = (
      <div className='row mbd'>
        <div className="col" style={{ marginTop: "5px",padding:'10px 10px',width:`100%` }}>
          <div className='col s12' style={{marginBottom:'10px'}}>
          {assets.map((a,index)=>(
            <>{this.renderImage(a)}</>
          ))}
          </div>
          <div className="col s6" style={{padding:0}}>
          <form onSubmit={this.onSubmit.bind(this)} autoComplete="off" style={{paddingRight:'10px'}}>
            <input
              id={`walletAddress`}
              onChange={this.onChangePriv.bind(this)}
              className="black-text passwordClass200"
              type="password"
              placeholder={`${currencies[this.state.title.toLowerCase()]}`}
              style={{ color: "black !important",maxWidth:'200px !important' }}
              required={true}
            />
          </form>
          </div>
          <div className="col s6" style={{padding:0,marginLeft:'-5px'}}>
            <p style={{marginleft:'5px',float:'left',marginTop:'8px'}}>Or</p>
              <Dropzone onDrop={this.onDrop.bind(this)}>
                {({ getRootProps, getInputProps }) => (
                  <div
                    style={{ cursor: "pointer", zIndex: 15, position: "absolute" }}
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    <button style= {{marginTop:'3px',marginLeft:'20px',padding:0,width:'100px'}} className="btn clickablesBlack"> Upload JSON</button>
                  </div>
                )}
              </Dropzone>
          </div>
          <div className='col s12' style={{padding:0}}>
            <p className="black-text" style={{ marginTop: "5px" }}>
              Address:
            </p>
            <p className="grey-text" style={{ marginBottom: "10px", height: "20px",wordBreak:'break-word' }} >
              {this.state.address ? this.state.address : `Please Enter In A Valid ${currencies[this.state.title.toLowerCase()]}`}
            </p>
          </div>
        </div>
      </div>
    );
    return (
      <Modal
        style={{ maxWidth: "500px" }}
        title={`Import ${this.state.title.toUpperCase().replace('NRG','OVERLINE')} Address`}
        id={`modalAddress`}
        classes="modal black-text"
        component={component}
        buttonText={"Confirm Import"}
        passwordId={`passAddress`}
        noClose={true}
        decryption={true}
        buttonAction={this.submitOperation.bind(this)}
      />
    );
  }
  setTitle(title){
    this.setState({title})
    let _this = this;
    this.props[`gen${title.replace("-", "").toUpperCase()}Wallet`](
      (wallet) => {
        this.setState({ wallet });
      }
    );
  }
  renderImage(title,filter) {

    let border = this.state.title === title.toLowerCase() ? '1px solid grey' : 'none';
    return (
      <img
        onClick={this.setTitle.bind(this,title.toLowerCase())}
        style={{border,cursor:'pointer'}}
        src={`./${title.toLowerCase()}.png`}
        className="assetLogo2"
      />
    );
  }
  // <Circle big={false} {...this.props}/>
  render() {
    return (
      <div className="col s12 center" style={{ width:'95%', marginTop: "10px",marginLeft:'2.5%'}}>
        <div className="col s6" style={{ marginBottom: "20px", marginTop: "10px", paddingRight:'5px',paddingLeft:'2px' }}>
          <button onClick={this.openModal.bind(this)} style= {{padding:0,width:'100%',fontSize:'10px'}} className="btn clickablesWhite"> Import
            <i className="material-icons" style={{float: 'right',marginRight:"5px"}}>arrow_circle_down</i>
          </button>
        </div>
        <div className="col s6" style={{ marginBottom: "20px", marginTop: "10px",paddingLeft:'5px',paddingRight:'2px' }}>
          <button onClick={this.openWallet.bind(this)} style= {{padding:0,width:'100%',fontSize:'10px'}} className="btn clickablesWhite"> Create
            <i className="material-icons" style={{float: 'right',marginRight:"5px"}}>add_circle_outline</i>
          </button>
        </div>
        <hr style={{borderColor:'grey',marginTop:'60px'}}/>
        {this.renderWallet()}
        {this.renderModal()}
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
  };
}

export default connect(mapStateToProps, {
  getBTCAddress,
  getETHAddress,
  getNEOAddress,
  getWAVAddress,
  getLSKAddress,
  getDAIAddress,
  getUSDTAddress,
  getEMBAddress,
  getNRGAddress,
  getLEMBAddress,
  genNEOWallet,
  genBTCWallet,
  genETHWallet,
  genLSKWallet,
  genWAVWallet,
  genDAIWallet,
  genUSDTWallet,
  genNRGWallet,
  genLEMBWallet,
  genEMBWallet,
  setAssetView,
  setBTCWallet,
  setETHWallet,
  setNEOWallet,
  setWAVWallet,
  setLSKWallet,
  getBalancesDispatch,
  removeAsset,
  removeWallet,
  setDAIWallet,
  setUSDTWallet,
  setEMBWallet,
  setNRGWallet,
  setLEMBWallet,
  getNEOTransfers,
  getBTCTransfers,
  getETHTransfers,
  getLSKTransfers,
  getWAVTransfers,
  getNRGTransfers,
  getEMBTransfers,
  getDAITransfers,
  getUSDTTransfers,
})(withRouter((props) => <Import {...props} />));
